import Api from 'libs/api/index';

class FacilityCompanyEmergencyContactsApi extends Api {
  constructor() {
    super('facility/company_emergency_contacts/');
  }

  sendMessage(ids, message) {
    return this.buildQuery(
      'post',
      {
        data: {
          ids,
          message,
        },
      },
      'send_message',
    );
  }

  confirm(token) {
    return this.buildQuery(
      'get',
      {
        data: {},
      },
      `confirm/${token}`,
    );
  }
}

export default FacilityCompanyEmergencyContactsApi;
